import React, { useContext, useState } from 'react';
import UserContext from './UserContext';
import { BaseURL } from '../../Files/BaseURL';
import AlertContext from '../Alert/AlertContext';
import axios from "axios"

const UserState = (props) => {
  const initialvalue = null;
  const [userDetail, setUserDetail] = useState(initialvalue);
  const {showAlert}= useContext(AlertContext)

  const fetchUser = async ()=>{
    try {
      const authToken = localStorage.getItem("p@token");
      if(!authToken){
        showAlert('Token not found','danger');
        return;
      }
      const response = await axios.get(`${BaseURL}/api/user/userstatus`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      });

      if (response.data) {
        setUserDetail(response.data);
      }
    } catch (error) {
      showAlert(error.message|| "Internal Server Error",'danger');
    }
  }

  return (
    <UserContext.Provider value={{fetchUser, userDetail,setUserDetail }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
